import { RequestService } from "../../../../common/services/RequestService";
import { EDIT_NIGHT_PLACEMENT } from "./constants";

export const editPlacementRequest = async (orderId, placementId, payload) => {
  const response = await RequestService.put(
    EDIT_NIGHT_PLACEMENT.replace("{order_id}", orderId).replace('{kids_night_list_id}', placementId),
    payload
  );

  return response;
};
